import React from "react";
import ComponentRegistry from "../../Common/ComponentRegistry";

export default class BasketController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
        this.store.listen(data => this.setState(data));

        this.state = this.store.state;
    }

    render() {
        const BasketView = ComponentRegistry.get(this.props.view);
        const BasketEmptyView = ComponentRegistry.get(this.props.emptyView);

        if (this.state.items.length === 0) {
            return (<BasketEmptyView {...this.props} />);
        }

        return (<BasketView {...this.props} value={this.state} />);
    }
}

BasketController.propTypes = {
    store: React.PropTypes.string,
    view: React.PropTypes.string,
    emptyView: React.PropTypes.string,

};

BasketController.defaultProps = {
    store: "BasketStore",
    view: "BasketViewsBasketView",
    emptyView: "BasketViewsEmptyBasketView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Controllers/BasketController.jsx